function Card({ img, title, description }) {
  return (
    <div
      className="rounded-xl md:h-96 h-40 w-full text-white flex justify-start items-end"
      style={{
        backgroundImage: `url('${img}')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="flex flex-col md:gap-2 md:px-6 md:pb-8 px-2 pb-3">
        <h3 className="text-2xs md:text-2xl font-semibold">{title}</h3>
        <p className="font-light text-3xs md:text-sm">{description} </p>
      </div>
    </div>
  );
}

export default Card;
